var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93727 1.75C9.7694 1.75087 10.5621 2.14812 11.0591 2.81225L11.8563 3.87275C12.1091 4.20875 12.5108 4.40912 12.9308 4.41H15.4061C18.7854 4.41 20.3595 6.14162 20.3595 9.8595L20.335 14.2056C20.3342 17.6776 18.1764 19.8354 14.7026 19.8354H7.8934C4.41265 19.8354 2.24965 17.6767 2.24965 14.203V7.37887C2.24965 3.6435 3.91127 1.75 7.18727 1.75H8.93727ZM8.9364 3.0625H7.18727C4.64627 3.0625 3.56215 4.354 3.56215 7.37887V14.203C3.56215 16.989 5.1004 18.5229 7.8934 18.5229H14.7026C17.4886 18.5229 19.0225 16.989 19.0225 14.203V14.2004L19.047 9.856C19.047 6.88187 18.0268 5.7225 15.4061 5.7225H12.9299C12.0995 5.72162 11.3068 5.32525 10.808 4.662L10.0091 3.59975C9.75802 3.26287 9.3564 3.06337 8.9364 3.0625ZM15.1263 12.4362C15.4886 12.4362 15.7826 12.7302 15.7826 13.0924C15.7826 13.4547 15.4886 13.7487 15.1263 13.7487H7.4832C7.12095 13.7487 6.82695 13.4547 6.82695 13.0924C6.82695 12.7302 7.12095 12.4362 7.4832 12.4362H15.1263Z",
    fill: "#5E5E5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.00cd8523.svg";
export { ForwardRef as ReactComponent };